import { createFileRoute } from '@tanstack/react-router';
import { AdminRoadmapView } from '@/components/admin/roadmap';

// Deep-linkable item detail: the GitHub issues the server files link back to
// `${PUBLIC_WEB_URL}/admin/roadmap/<id>`.
export const Route = createFileRoute('/_authed/admin/roadmap/$itemId')({
  component: AdminRoadmapItemPage,
});

function AdminRoadmapItemPage() {
  const { itemId } = Route.useParams();
  return <AdminRoadmapView tab="all" itemId={itemId} />;
}
